import { useState, ChangeEvent, MouseEvent, Dispatch, SetStateAction } from "react";
import API from '../../../../api';
import { CircularProgress, Autocomplete, TextField, AutocompleteInputChangeReason } from "@mui/material";
import SelectField from "../../../../components/Form/SelectFields";
import Ketcher from "../../../../components/Data/Ketcher";
import CopyToClipbardButton from "../../../../components/Buttons/CopyToClipboardButton";

const options = [
    {value: 'Name', label: 'Name'},
    {value: 'CAS Number', label: 'CAS Number'},
    {value: 'SMILES', label: "SMILES"},
]

interface AutoCompleteResponse {
    cas: string,
    itn: string,
    label: string,
    name: string,
    subsKey: string,
    value: string,
}
export default function SelectCompound({
    smiles,
    setSmiles
}: {
    smiles: string,
    setSmiles: Dispatch<SetStateAction<string>>,
}) {
    const [ selection, setSelection ] = useState({value: 'Name', label: 'Name'});
    const [ results, setResults ] = useState<{label: string, cas: string}[]>([]);
    const [ ketcherInstance, setKetcherInstance ] = useState<any | null>(null);
    const [ isLoading, setIsLoading ] = useState(false);

    const handleAutoComplete = async (e: ChangeEvent<HTMLInputElement>, inputValue?: string) => {

        const value = inputValue ? inputValue : e.target.value;
        // setSearchInput(value);

        let list: {label: string, cas: string}[] = [];

        if (!value) {
            list = [];
        } else {
            setIsLoading(true);
            if (selection.value === 'Name') {
                try {
                    const response = await API.get(`https://cdxappsdev.epacdx.net/oms-substance-registry-services/rest-api/autoComplete/nameSearch?term=${value}&qualifier=begins`);
                    const data: AutoCompleteResponse[] = await response.data;
                    list = data.map(d => ({label: d.name, cas: d.cas}));
                } catch (err:any) {
                    console.log(err)
                }
            } else if (selection.value === 'CAS Number') {
                try {
                    const response = await API.get(`https://cdxappsdev.epacdx.net/oms-substance-registry-services/rest-api/autoComplete/casSearch?term=${value}`);
                    const data: AutoCompleteResponse[] = await response.data;
                    list = data.map(d => ({label: d.cas, cas: d.cas}));
                } catch (err:any) {
                    console.log(err)
                }
            } else if (selection.value === 'SMILES') {
                try {
                    await ketcherInstance.setMolecule(value);
                    setSmiles(value);
                    list = [];
                    
                
                } catch (err:any) {
                    console.log(err);
                }
            }
            setIsLoading(false);
        }

        setResults(list);
    
}

const handleSelection = async (e:any) => {
    setSelection({value: e.value, label: e.value});
    // setSearchInput('');
    setResults([]);
    await ketcherInstance.setMolecule('');
}

const handleMoleculeSelection = async (e: MouseEvent<HTMLButtonElement>, result: {label: string, cas: string}) => {
    e.preventDefault();
    const { cas } = result;
    setResults([]);
    // setSearchInput(label);

    try {
        const response = await API.get(`https://cdxapps.epa.gov/oms-substance-registry-services/rest-api/substance/cas/${cas}`);
        const data = await response.data;
        const smiles = data[0].smilesNotation;
        
        
        await ketcherInstance.setMolecule(smiles);
        setSmiles(smiles);

    } catch (err:any) {
        console.log(err);
    }

}

    return (
        <>
            <div className="flex flex-col gap-10">
                <div className="w-full flex justify-start items-center gap-4">
                    <div className="w-full flex flex-col gap-2 justify-start items-start grow">
                        <label className="text-[12px] font-medium text-default">Search</label>
                        <Autocomplete
                            id="free-solo-demo"
                            freeSolo
                            disableClearable
                            sx={{
                                width: '100%',
                                backgroundColor: '#ffffff',
                                fontFamily: 'Montserrat',
                            }}
                            componentsProps={{
                                paper: {
                                  sx: {
                                    '& .MuiAutocomplete-listbox': {
                                      fontFamily: 'Montserrat, sans-serif',
                                    },
                                  },
                                },
                              }}

                            onChange={(e:any, option: any) => handleMoleculeSelection(e, option)}
                            onInputChange={(e:any, value: string, reason: AutocompleteInputChangeReason) => handleAutoComplete(e, value)}
                            options={results}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField sx={{fontFamily: 'Montserrat, sans-serif'}} {...params} label="" placeholder="Search" InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                    {isLoading ? <CircularProgress size={20} color="inherit" className="mr-4"/> : null}
                                    </>
                                ),
                                type: 'search',
                                style: {
                                    fontFamily: 'Montserrat, sans-serif', 
                                    padding: '4px 12px', 
                                    borderRadius: '8px', 
                                    borderColor: '#C1C7CD'
                                }
                              }}/>}
                        />
                    </div>
                    <SelectField 
                        label='By'
                        id='selection'
                        name='selection'
                        value={selection}
                        isRequired={false}
                        isCreatable={false}
                        isMulti={false}
                        options={options}
                        handleChange={handleSelection}
                    />
                </div>
                <div className="rounded-xl overflow-hidden w-full h-[400px] grow border border-outline relative">
                    <Ketcher setSmiles={setSmiles} setKetcherInstance={setKetcherInstance}/>
                    {!ketcherInstance && <div className="flex justify-center items-center absolute top-0 right-0 bottom-0 left-0"><CircularProgress size={80} color="inherit" /></div>}
                </div>
            </div>
            {smiles ? (
                <div className="w-full flex flex-col gap-2 justify-start items-start">
                    <label className="text-[12px] font-semibold text-default flex justify-start items-center gap-2">
                        Generated SMILES Output
                        <CopyToClipbardButton copyValue={smiles}/>
                    </label>
                    <div className={`w-full rounded-lg px-4 py-3 border border-outline break-all text-outline`}>{smiles ? smiles : 'No SMILES selected'}</div>
                </div>
            ) : (
                <></>
            )}
        </> 
    )
}